/** Only failed transports are connectivity errors; HTTP/application errors remain unchanged. */
export class ConnectionError extends Error {
	constructor(cause: unknown) {
		super("We couldn't reach Forento. Check your connection and try again.", { cause })
		this.name = "ConnectionError"
	}
}

export function isConnectionError(error: unknown): boolean {
	const seen = new Set<unknown>()
	while (error instanceof Error && !seen.has(error)) {
		if (error instanceof ConnectionError) return true
		seen.add(error)
		error = error.cause
	}
	return false
}

let connectionFailed = false
const listeners = new Set<() => void>()

export const getConnectionFailed = () => connectionFailed
export function subscribeConnection(listener: () => void) {
	listeners.add(listener)
	return () => {
		listeners.delete(listener)
	}
}
function setConnectionFailed(value: boolean) {
	if (connectionFailed === value) return
	connectionFailed = value
	for (const listener of listeners) listener()
}

/** Used by the interactive API client, not teardown heartbeats or third-party requests. */
export const connectionFetch: typeof fetch = async (input, init) => {
	try {
		const response = await fetch(input, init)
		setConnectionFailed(false)
		return response
	} catch (error) {
		const signal = init?.signal ?? (input instanceof Request ? input.signal : undefined)
		if (signal?.aborted || (error instanceof Error && error.name === "AbortError")) throw error
		if (!(error instanceof TypeError) && !(error instanceof Error && error.name === "NetworkError")) throw error
		setConnectionFailed(true)
		throw new ConnectionError(error)
	}
}
